<template>
  <v-dialog
    v-model="showDialogBlockUser"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="600"
    persistent
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          <span>{{
            $t("titleDialogBlockUser", {
              idReason: $t(currentIdReasonTranslate)
            })
          }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text
        class="white--text"
        :class="
          $vuetify.breakpoint.smAndDown ?
            'pa-8' :
            'px-16 pt-8'
        "
      >
        <div v-if="reasonDialogBlockUser.message" class="my-4">
          {{ $t("messageDialogBlockUser.reason") }}
          <!--! OBS IMPORTANTE -->
          <!--! DEVEM SER CRIADOS TRADUÇÕES DOS NOVOS MOTIVOS -->
          <!--! (NOVOS MOTIVOS SÃO CRIADOS NO SUPORTE) -->
          {{ $t(`messageDialogBlockUser.messagesTranslate.${
            reasonDialogBlockUser.message.split(":", 1)
          }`) }}
        </div>

        <div>{{
          $t("messageDialogBlockUser.getExplainingWithSupport", {
            idReason: $t(currentIdReasonTranslate)
          })
        }}</div>
      </v-card-text>

      <v-card-actions
        :class="
          $vuetify.breakpoint.smAndDown ?
            'px-8 pt-0' :
            'px-16 pt-3 pb-8'
        "
      >
        <v-btn block color="primary" @click="contactSupport">
          {{ $t("messageDialogBlockUser.contactSupport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-block-user",

  data: () => ({
    idReasonsTranslate: {
      // Inserir a variável de tradução como valor do "block_type"
      aposta: "theBet",
      saque: "tabWithdraw",
    },
  }),

  created() {
    // Reset dialog data
    this.$store.commit("resetDialogBlockUser");
  },

  computed: {
    showDialogBlockUser() {
      return this.$store.getters.getDialogBlockUserStatus;
    },
    reasonDialogBlockUser() {
      return this.$store.getters.getDialogBlockUserReason;
    },
    currentIdReasonTranslate() {
      return this.idReasonsTranslate[this.reasonDialogBlockUser.id] ||
        this.reasonDialogBlockUser.id;
    },
  },

  watch: {
    $route() {
      // Reset dialog data
      this.$store.commit("resetDialogBlockUser");
    },
  },

  methods: {
    closeDialog() {
      this.$store.commit("resetDialogBlockUser");
    },
    contactSupport() {
      this.$router.push({
        path: `/page/company/contact`,
        query: {
          email: this.$store.state.operators.contact_email
        }
      });
      this.$store.commit("resetDialogBlockUser");
    },
  },
}
</script>